<script>
export default {
  name: 'AetherpayDepositDetails',
  props: {
    deposit: { type: Object, default: null },
    busy: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  computed: {
    checkoutUrl() {
      const url = this.deposit && this.deposit.checkoutUrl
      return typeof url === 'string' && /^https:\/\/aetherpay\.vip\/c\.html\?id=[a-f0-9]{32}$/.test(url) ? url : ''
    },
    terminal() { return this.deposit && ['EXPIRED', 'CANCELLED', 'REFUNDED'].includes(this.deposit.status) },
    canOpen() { return this.deposit && ['PENDING', 'EXPIRED'].includes(this.deposit.status) && this.checkoutUrl },
    formattedAmount() {
      return this.deposit ? Number(this.deposit.amount).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''
    },
  },
}
</script>
<template>
  <section class="aetherpay" aria-label="ฝากเงิน AETHERPAY">
    <h4 class="aetherpay-title">AETHERPAY</h4>
    <p v-if="!deposit && busy" role="status">กำลังเตรียมรายการฝากเงิน</p>
    <template v-if="deposit">
      <p class="aetherpay-amount">{{ formattedAmount }} บาท</p>
      <p v-if="deposit.status === 'PAID'" role="status">{{ deposit.successful ? 'ฝากเงินสำเร็จ' : 'รับชำระแล้ว กำลังตรวจสอบเครดิต' }}</p>
      <p v-else-if="deposit.status === 'EXPIRED'">รายการหมดอายุ หากโอนแล้วให้เปิดรายการเดิมเพื่อแนบสลิป</p>
      <p v-else-if="terminal">รายการนี้สิ้นสุดแล้ว</p>
      <p v-else>กรุณาโอนตามยอดที่แสดงให้ตรงทุกสตางค์ และแนบสลิปในหน้าชำระเงิน</p>
      <iframe v-if="checkoutUrl && deposit.status === 'PENDING'" :src="checkoutUrl" title="หน้าชำระเงิน AETHERPAY"
        class="aetherpay-checkout" referrerpolicy="no-referrer" />
      <a v-if="canOpen" :href="checkoutUrl" target="_blank" rel="noopener noreferrer" referrerpolicy="no-referrer"
        class="aetherpay-link" @click="$emit('attach-slip')">เปิดหน้าชำระเงิน / แนบสลิป</a>
    </template>
    <p v-if="error" class="aetherpay-error" role="alert">{{ error }}</p>
    <div class="aetherpay-actions">
      <button type="button" :disabled="busy" @click="$emit('check')">{{ busy ? 'กำลังตรวจสอบ…' : 'ตรวจสอบรายการ' }}</button>
      <button v-if="terminal" type="button" :disabled="busy" @click="$emit('restart')">สร้างรายการใหม่ (ยังไม่ได้โอน)</button>
    </div>
  </section>
</template>
<style scoped>
.aetherpay { color: #222; background: #fff; padding: 18px; border-radius: 12px; text-align: center; }
.aetherpay-title { font-weight: 700; margin: 0 0 10px; }
.aetherpay-amount { font-size: 26px; font-weight: 700; }
.aetherpay-checkout { width: 100%; height: 560px; border: 0; border-radius: 8px; }
.aetherpay-link { display: block; color: #164f9c; padding: 12px 0; text-decoration: underline; }
.aetherpay-error { color: #a51b27; overflow-wrap: anywhere; }
.aetherpay-actions { display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin-top: 12px; }
.aetherpay-actions button { padding: 10px 14px; border: 1px solid #bbb; border-radius: 6px; background: #f5f5f5; color: #222; }
.aetherpay-actions button:disabled { opacity: .55; }
</style>
